import store from '@/store/index';
import { risingAPI } from "@/api/baseApi";
export const setFavoriteCoinList = async (params) => {
    // const config = useRuntimeConfig();
    // const userStore = useUserStore();
    const favoriteList = store.getters['userInfo/favoriteList'];
    const user_no = store.state.userInfo.risingUserInfo.user_no
    
    let transformCoin = params.coinName.replace('USDT',"")
    if(favoriteList.includes(transformCoin)) {
        const fi = favoriteList.findIndex(ob => ob === transformCoin);
        favoriteList.splice(fi, 1);
    } else {
        favoriteList.push(transformCoin);
    }
    console.log('favorites_list',favoriteList);
    
    try {
        // const options = {
        //     // url    : `${config.public.wedataApiBase}/fav-coin-list`,
        //     method : "PUT",
        //     body   : bodyData,
        //     option : {
        //         credentials: "include"
        //     }
        // }
        let bodyData = {};        
        let result;
        if(favoriteList.length > 0) {
            bodyData.favorites_list = Array.from(new Set(favoriteList))
            result = await risingAPI.put('/fav-coin-list',bodyData)
        }else {
            bodyData.user_favorites_no = user_no
            console.log('bodyData',bodyData);
            
            result = await risingAPI.delete('/fav-coin-list',{params:bodyData})
        }

        console.log('put favorite list data ',result.data);
        // const {data, error} = await useCustomPostData(`${DateUtil.getUnixTime()}`, options);
        if(result.data.error) {
            return {error: result.data.error}
        }
        await store.dispatch('userInfo/fetchUser');
        return {status: "ok"};
    } catch (e) {
        return {error : e}
    }
}